var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .a {\n        fill: none;\n        stroke: #97a6aa;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    ")),React.createElement("g",{"transform":"translate(0.75 11.061) rotate(-90)","key":1},[React.createElement("path",{"className":"a","d":"M10,0,5,5,0,0","transform":"translate(0 9.558)","key":0}),React.createElement("line",{"className":"a","y1":"14.558","transform":"translate(5)","key":1})])]);
}

Arrow.defaultProps = {"viewBox":"0 0 16.058 12.121"};

module.exports = Arrow;

Arrow.default = Arrow;
